import React, { useEffect, useState } from "react";
import {
  DeleteOutlined,
  DownloadOutlined,
  GroupOutlined,
  MailOutlined,
  UserOutlined
} from "@ant-design/icons";
import { Col, Dropdown, Layout, Menu, Row, theme } from "antd";
import "./style.css";
import { useSelector } from "react-redux";
import { SelectUser } from "../../../store/usersSlice";
import {
  collection,
  doc,
  getDocs,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../../../firebase";
import { useDispatch } from "react-redux";
import { SelectChatUser, setChatUserInfo } from "../../../store/chatUserSlice";
import Search from "./components/Search";
import MessageInput from "./components/MessageInput";
import Messages from "./components/Messages";
import AllUserMessages from "./components/AllUserMessages";

const { Header, Content, Sider } = Layout;

function Chat() {
  const [users, setUsers] = useState([]);
  const [chats, setChats] = useState([]);
  const [isAllUserChatShown, setIsAllUserChatShown] = useState(false);
  const [reloadMessages, setReloadMessages] = useState(false);

  const currentUser = useSelector(SelectUser);
  const data = useSelector(SelectChatUser);
  console.log("User Data", currentUser);

  const dispatch = useDispatch();

  useEffect(() => {
    const getChats = () => {
      const unsub = onSnapshot(
        doc(
          db,
          "companies",
          currentUser?.companyName,
          "userChats",
          currentUser.uid
        ),
        (doc) => {
          setChats(doc.data());
        }
      );

      return () => {
        unsub();
      };
    };

    currentUser.uid && getChats();
  }, [currentUser.uid]);

  useEffect(() => {
    const getUsers = async () => {
      const userRef = collection(
        db,
        "companies",
        currentUser?.companyName,
        "users"
      );

      const snapShot = await getDocs(userRef);
      const fetchedData = snapShot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setUsers(fetchedData);
    };

    currentUser.companyName && getUsers();
  }, [currentUser.companyName]);

  console.log("chats", chats);
  console.log("chats test", Object.entries(chats));

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const menuOptions = [
    {
      icon: MailOutlined,
      label: "Channels",
      childrenItems: [{label: "All Users", icon: GroupOutlined}],
    },
    {
      icon: MailOutlined,
      label: "Direct Messages",
      childrenItems:
        Object.entries(chats).length > 0 ? Object.entries(chats) : [],
    },
  ];

  const [selectedUser, setSelectedUser] = useState("");

  const handleAllUserSelect = () => {
    setIsAllUserChatShown(true);
  }

  const handleSelect = (value) => {
    setIsAllUserChatShown(false);
    const payloadData = { chatId: currentUser?.uid, user: value };
    console.log("payloadDatapayloadData", payloadData);
    dispatch(setChatUserInfo(payloadData));
    const filteredUser = users.find((item)=> item.uid === payloadData.user.uid);
    setSelectedUser(filteredUser.profile.firstName + " " + filteredUser.profile.lastName);
  };

  const menuItems = menuOptions.map((item, index) => {
    const key = String(index + 1);
    return {
      key: `sub${key}`,
      icon: React.createElement(item.icon),
      label: item.label,
      children: index === 0 ? item.childrenItems.map((subItem, j) => {
        const subKey = index * 4 + j + 1;
        return {
          key: subKey,
          icon: React.createElement(subItem.icon),
          label: (
            <span onClick={() => handleAllUserSelect()}>
              {subItem.label}
            </span>
          ),
        };
      }) : item.childrenItems.map((subItem, _) => {
        // const subKey = index * 4 + j + 1;
        return {
          key: subItem[0],
          icon: React.createElement(UserOutlined),
          label: (
            <span onClick={() => handleSelect(subItem[1].userInfo)}>
              {subItem[1].label}
            </span>
          ),
        };
      })
    };
  });

  const defaultOpenKeys = menuItems.map((menuItem) => menuItem.key);

  const items = [
    {
      label: "Clear Chat",
      key: "1",
      icon: <DeleteOutlined />,
    },
    {
      label: "Download Chat",
      key: "2",
      icon: <DownloadOutlined />,
    },
  ];

  const handleMenuClick = (e) => {
    console.log("click", e);
  };
  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const handleButtonClick = (e) => {
    console.log("click left button", e);
    // Add your code to handle the button click action here
  };

  return (
    <>
      <div>
        <Layout style={{ height: "calc(100vh - 189px)" }}>
          <Sider
            breakpoint="lg"
            collapsedWidth="0"
            onBreakpoint={(broken) => {
              console.log(broken);
            }}
            onCollapse={(collapsed, type) => {
              console.log(collapsed, type);
            }}
            style={{
              height: "100%",
              border: "1px solid silver",
              backgroundColor: "white",
              borderRadius: "10px 0 0 10px",
            }}
          >
            <div className="demo-logo-vertical" />
            <h2
              style={{
                textAlign: "center",
                padding: "20px 0 15px 0",
                borderBottom: "1px solid silver",
                marginBottom: "10px",
              }}
            >
              SayEagle
            </h2>
            {/* <span onClick={()=>setIsAllUserChatShown(true)}>All Users</span> */}
            <Search />
            <Menu
              theme="light"
              mode="inline"
              items={menuItems}
              defaultOpenKeys={defaultOpenKeys}
              className="chat-menu-item"
            />
          </Sider>
          <Layout>
            <Header
              style={{
                padding: 0,
                background: colorBgContainer,
                border: "1px solid silver",
                borderLeft: "none",
                borderRadius: "0px 10px 0 0",
              }}
            >
              <Row justify="space-between" align="middle">
                <Col>
                  <p style={{ fontWeight: "bold" }}>{selectedUser}</p>
                </Col>
                <Col>
                  <Dropdown.Button
                    trigger="click"
                    menu={menuProps}
                    onClick={handleButtonClick}
                  >
                    Download Chat
                  </Dropdown.Button>
                </Col>
              </Row>
            </Header>
            <Content style={{ overflowY: "auto" }}>
            {
              isAllUserChatShown ? <AllUserMessages users={users} reloadMessages={reloadMessages}/> : <>{data?.chatId ? <Messages users={users}/> : null}</>
            }
              
            </Content>
            <MessageInput isAllUserChatShown={isAllUserChatShown} setReloadMessages={setReloadMessages} reloadMessages={reloadMessages}/>
          </Layout>
        </Layout>
      </div>
    </>
  );
}

export default Chat;
